import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { StringOrNumber } from "../../Types";

export const apiCallGetUserEditProfile = async ({
  userId
}: {
  userId: number;
}): Promise<{
  data: {
    userUUID: string;
    archiveData: {
      key: string;
      value: StringOrNumber;
      description: string;
      dateChange: string;
      changedBy: string;
    }[];
    userEditData: {
      key: string;
      value: StringOrNumber;
      numberOfChange: number;
    }[];
    gender: string;
    status: string;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    userUUID: string;
    archiveData: {
      key: string;
      value: StringOrNumber;
      description: string;
      dateChange: string;
      changedBy: string;
    }[];
    userEditData: {
      key: string;
      value: StringOrNumber;
      numberOfChange: number;
    }[];
    gender: string;
    status: string;
  }>(`user/getUserDataEditedByAdmin`, {
    userID: userId
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        userUUID: "",
        archiveData: [
          {
            key: "",
            value: "",
            description: "",
            dateChange: "",
            changedBy: ""
          }
        ],
        userEditData: [
          {
            key: "",
            value: "",
            numberOfChange: 0
          }
        ],
        gender: "",
        status: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        userUUID: "",
        archiveData: [
          {
            key: "",
            value: "",
            description: "",
            dateChange: "",
            changedBy: ""
          }
        ],
        userEditData: [
          {
            key: "",
            value: "",
            numberOfChange: 0
          }
        ],
        gender: "",
        status: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
